import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  orderInfo: {},
  orderConfirmAmount: {},
  orderConfirmInfo: {
    // 是否需要展示收货地址
    showAddress: false,
    // 可选资源数据
    choosableInfo: {},
    // 附加信息
    collectInfoService: [],
    // 需要收集的出行人信息数
    collectTravelerLength: 0,
    // 联系人姓名
    contactName: '',
    // 联系人电话
    contactPhone: '',
    // 备注
    remark: '',
    // 签证产品出行日期
    goTimeVisa: '',
    // 联系人邮箱
    contactEmail: ''
  }
};

export default function orderConfirm(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  console.log(type,'typetypetypetypetypetypetype')
  switch (type) {
    // 获取订单确认页信息
    case ACTION_TYPES.GET_ORDER_CONFIRM:
      result.orderInfo = payload;
      result.orderConfirmAmount = {
        // 订单原始金额
        originAmount: payload.originAmount,
        // 订单打折的金额
        vipDiscountAmount: payload.vipDiscountAmount,
        // 订单最终金额
        tradeAmount: payload.tradeAmount
      }
      break;
    // 获取订单确认页金额信息
    case ACTION_TYPES.CHECK_TRADE_AMOUNT_NEW:
      result.orderConfirmAmount = payload;
      break;
    // 设置订单确认页填写的信息
    case ACTION_TYPES.SET_ORDER_CONFIRM_INFO:
      result.orderConfirmInfo = {
        ...result.orderConfirmInfo,
        ...payload
      };
      break;
    // 清除订单确认页填写的信息
    case ACTION_TYPES.CLEAR_ORDER_CONFIRM_INFO:
      result = INIT_STATE;
      break;
    default:
      result = state;
  }
  return result;
}
